import httpClient from '../httpClient';

const getProfileSelector = async () => {
  return await httpClient.get(`profiles/`);
};

const getProfile = async (id) => {
  return await httpClient.get(`profiles/${id}`);
}

const getModulesProfile = async (idProfile) => {
  return await httpClient.get(`profiles_modules/by-profile/${idProfile}/`);
}

const createProfile = async (data) => {
  return await httpClient.post(`profiles/`, data);
}

const updateProfileModules = async (data) => {
  return await httpClient.put(`profiles_modules/change-profile/`, data);
}

export {
  getProfileSelector,
  getProfile,
  getModulesProfile,
  createProfile,
  updateProfileModules,
};
